import React, { useEffect, useState } from "react"
import { Input, message, Modal, Tooltip } from "antd"
import dayjs from "dayjs"

import TableCustom from "src/components/Table/CustomTable"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import ProposalService from "src/services/ProposalService"
import ModalDetailProposal from "../Modal/ModalDetailProposal"
import FilterRequest from "./FilterRequest"
import CustomModal from "src/components/Modal/CustomModal"
import ImportModal from "src/pages/ADMIN/Bussiness/Contact/modal/ImportModalSim"
import ModalInputSim from "../Modal/ModalUpdateSim"
import { set } from "lodash"

const STATUS_LIST = [
  { id: "1", name: "Chờ duyệt" },
  { id: "2", name: "Đã duyệt" },
  { id: "3", name: "Từ chối" },
]

const DISCOUNT_TYPE_LIST = [
  { key: "percent", name: "Chiết khấu trước VAT" },
  { key: "fixed", name: "Chiết khấu sau VAT" },
]

const ActionItem = ({ icon, label, onClick }) => (
  <div
    onClick={e => {
      e.stopPropagation()
      onClick()
    }}
    className="action-item"
  >
    <IconBase name={icon} />
    <span>{label}</span>
  </div>
)

const getStatusName = id => STATUS_LIST.find(s => s.id === id)?.name || ""
const getDiscountTypeName = key =>
  DISCOUNT_TYPE_LIST.find(d => d.key === key)?.name || ""
const simTypeMap = {
  1: "Sim vật lý",
  2: "E-SIM",
}
const ListWarehouseInRequest = ({
  type,
  tabStatus,
  permissions,
  setParentFilter,
  setExcelKeyword,
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })

  const [viewModalVisible, setViewModalVisible] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [rejectModalVisible, setRejectModalVisible] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [rejectReason, setRejectReason] = useState("")
  const [refresh, setRefresh] = useState(false)
  const [approveModalVisible, setApproveModalVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [filter, setFilter] = useState({})
  const [summary, setSummary] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isModalImport, setIsModalImport] = useState(false)
  const [isModalUpdate, setIsModalUpdate] = useState(false)
  const [idUpdate, setIdUpdate] = useState()
  const [checkStatus, setCheckStatus] = useState({
    request_id: null,
    supplierCode: null,
  })
  const [isApprove, setIsApprove] = useState(false)

  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
    setParentFilter(filter)
  }, [refresh, filter, keyword, tabStatus])
  useEffect(() => {
    console.log("Refreshing table data...")
    fetchData(pagination, filter, keyword, tabStatus)
    setParentFilter(filter)
  }, [pagination.current, pagination.pageSize])

  const fetchData = async (pagi, filter, keyword, tabStatus) => {
    setLoading(true)
    setExcelKeyword(keyword)
    try {
      console.log(pagi, "panigation")
      const res = await ProposalService.getListProposal({
        page: pagi.current,
        per_page: pagi.pageSize,
        filter: {
          ...filter,
          status: tabStatus,
        },
        keyword,
      })

      if (res.success) {
        let filteredData = res.success.data
        const users = res?.success?.data || []
        const total = res?.success?.total || users.length
        const current = res.current_page
        const perPage = res.success?.per_page
        const transformedData = filteredData.map(item => {
          const unitPrice = Number(item.unit_price || 0)
          const discountValue = Number(item.discount || 0)
          const discountType = item.discount_type // 'fixed' | 'percent'
          const total_before_vat = item.total_before_vat
          const total_after_vat = item.total_after_vat

          // let finalPrice = total_after_vat

          // if (discountType === "percent") {
          //   finalPrice = (total_before_vat * discountValue) / 100
          // } else if (discountType === "fixed") {
          //   finalPrice = (total_after_vat * discountValue) / 100
          // }

          // if (finalPrice < 0) finalPrice = 0

          return {
            ...item,
            create_at: dayjs(item.create_at).format("DD-MM-YYYY"),
            createBy: item.createby?.fullname || "",
            status_name: getStatusName(item.status),
            discount_type: getDiscountTypeName(item.discount_type),
            total_amount: unitPrice.toLocaleString(),
            discount: discountValue.toLocaleString(),
            // final_amount: finalPrice.toLocaleString(), // ✅ Giá sau chiết khấu
            supplier: item.supplier.name || "",
            supplier_code: item.supplier.code || "",
            customer: item.customer?.fullname || "",
            export_code: item.export?.export_code || "",
            sim_type_check: item.sim_type,
            sim_type: simTypeMap[item.sim_type] || "",
            total_after_vat: Number(item.total_after_vat).toLocaleString(),
            total_before_vat: Number(item.total_before_vat).toLocaleString(),
            end_price: Number(item.end_price).toLocaleString(),
          }
        })
        setData(transformedData)
        setPagination({
          ...pagi,
          total: total,
        })
        setSummary({
          totalAccounts: total,
        })
      }
    } catch (err) {
      message.error("Lỗi khi tải dữ liệu: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleAction = (action, record) => {
    setSelectedRecord(record)
    switch (action) {
      case "view":
        setViewModalVisible(true)
        break
      case "edit":
        setEditModalVisible(true)
        break
      case "update":
        console.log("record :", record)
        setCheckStatus({
          request_id: record.request_id,
          supplierCode: record.supplier_code,
        })
        setIdUpdate(record.ID)
        setIsModalUpdate(true)
        break
      case "approve":
        setSelectedRecord(record)
        setApproveModalVisible(true)
        setIsApprove(true)
        // setRefresh(prev => !prev)
        break
      case "reject":
        setRejectModalVisible(true)
        setIdUpdate(record.id)
        // setRefresh(prev => !prev)
        break
      case "export":
        exportExcelProposal(record)
        break
      case "import":
        setSelectedRecord(record)
        console.log(selectedRecord, "slt rc")
        setIsModalImport(true)
        break
      case "buy-from-supplier":
        // setSelectedRecord(record)
        // setIsModalBuyFromSupplier(true)
        handleBuyFromProvider(record)
        break
      default:
        break
    }
  }
  const handleBuyFromProvider = async record => {
    setLoading(true)
    try {
      const res = await ProposalService.buyFromProvider({ id: record.ID })

      message.success(res.message)
      setRefresh(prev => !prev)
    } catch (err) {
      // Kiểm tra nếu có phản hồi từ server
      if (err.response?.status === 401) {
        message.error(err.response?.data?.message || "Không thể nhập phiếu")
      } else {
        message.error(
          err.response?.data?.message || "Lỗi khi nhập: " + err.message,
        )
      }
    } finally {
      setLoading(false)
    }
  }

  const approveProposal = async record => {
    setLoading(true)
    try {
      const res = await ProposalService.approveProposal(
        record.ID ? record.ID : record,
      )
      if (res.message === "Duyệt phiếu đề xuất thành công.") {
        message.success("Duyệt phiếu nhập kho thành công")
        setRefresh(prev => !prev)
      } else {
        message.error(res.message || "Không thể duyệt phiếu")
      }
    } catch (err) {
      // Kiểm tra nếu có phản hồi từ server

      const messageCheck =
        "Phiếu đề xuất không được phép duyệt vì chưa có đơn giá phiếu nhập kho"

      if (err.response?.status === 401) {
        message.error(err.response?.data?.message || "Không thể duyệt phiếu")
        setIdUpdate(record.ID)
        if (
          !Boolean(Number(selectedRecord.end_price)) &&
          err.response.data.message === messageCheck
        ) {
          setEditModalVisible(true)
        } else {
          setIsModalUpdate(true)
        }
      } else {
        message.error(
          err.response?.data?.message || "Lỗi khi duyệt: " + err.message,
        )
      }
    } finally {
      setLoading(false)
    }
  }

  const rejectProposal = async () => {
    if (!rejectReason.trim())
      return message.warning("Vui lòng nhập lý do từ chối")

    setLoading(true)
    try {
      const res = await ProposalService.refuseProposal(selectedRecord.ID, {
        note: rejectReason,
      })
      if (
        res.message ===
        "T\u1eeb ch\u1ed1i phi\u1ebfu \u0111\u1ec1 xu\u1ea5t th\u00e0nh c\u00f4ng."
      ) {
        // Nếu phản hồi có message thành công
        message.success("Từ chối phiếu nhập kho thành công")
        setRejectModalVisible(false)
        setRejectReason("")
        setRefresh(prev => !prev)
      } else {
        // Nếu không có message thành công, hiển thị thông báo lỗi
        message.error("Không thể từ chối phiếu")
      }
    } catch (err) {
      message.error("Lỗi khi từ chối: " + err.message)
    } finally {
      setLoading(false)
    }
  }
  const exportExcelProposal = async record => {
    setLoading(true)
    try {
      const res = await ProposalService.exportExcelProposal({
        warehouse_approval_id: record.ID,
      })

      // Tạo link tải file từ blob
      const url = window.URL.createObjectURL(new Blob([res]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute(
        "download",
        `Phiếu nhập kho ${record.batch_number}.xlsx`,
      ) // tên file tải về
      document.body.appendChild(link)
      link.click()
      link.remove()

      message.success("Xuất excel phiếu nhập kho thành công")
    } catch (err) {
      message.error("Lỗi khi xuất excel phiếu nhập kho: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    // { title: "STT", render: (_, __, i) => i + 1 },
    { title: "Số lô nhập", dataIndex: "batch_number", align: "center" },
    { title: "Mã đơn hàng", dataIndex: "export_code", align: "center" },
    { title: "Khách hàng", dataIndex: "customer", align: "center" },
    { title: "Nhà cung cấp", dataIndex: "supplier", align: "center" },
    { title: "Loại SIM", dataIndex: "sim_type", align: "center" },
    {
      title: "Ngày tạo phiếu",
      dataIndex: "created_at",
      align: "center",
      render: text => {
        const date = new Date(text)
        return date.toLocaleString("vi-VN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      },
    },
    { title: "Số lượng SIM", dataIndex: "quantity", align: "center" },
    {
      title: "Tổng tiền trước VAT",
      dataIndex: "total_before_vat",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền sau VAT",
      dataIndex: "total_after_vat",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    { title: "Loại chiết khấu", dataIndex: "discount_type", align: "center" },
    { title: "Chiết khấu (%)", dataIndex: "discount", align: "center" },
    {
      title: "Tổng tiền sau chiết khấu",
      dataIndex: "end_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Loại tiền tệ",
      dataIndex: "currency_type",
      align: "center",
      render: value => {
        if (value === "vnd") return "VND"
        if (value === "usd") return "USD"

        return value
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      fixed: "right",
      render: status => {
        let statusText = ""
        let statusColor = ""

        switch (status) {
          case "1":
            statusText = "Chờ duyệt"
            statusColor = "orange"
            break
          case "2":
            statusText = "Đã duyệt"
            statusColor = "green"
            break
          // case "3":
          //   statusText = "Từ chối"
          //   statusColor = "red"
          //   break
          default:
            statusText = "Không xác định"
            statusColor = "gray"
            break
        }

        return (
          <span style={{ color: statusColor, fontWeight: "bold" }}>
            {statusText}
          </span>
        )
      },
    },
    { title: "Người đề xuất", dataIndex: "createBy", align: "center" },

    {
      title: <Tooltip title="Hành động">_</Tooltip>,
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const isPending = record.status === "1"
        const isEsim = record.sim_type_check == 2
        const supplierName = record.supplier

        return (
          <PopupAction>
            {permissions.includes("warehouse.propose.detail") ? (
              <ActionItem
                icon="eye"
                label="Xem chi tiết"
                onClick={() => handleAction("view", record)}
              />
            ) : (
              <React.Fragment />
            )}

            {permissions.includes("warehouse.propose.update") && isPending ? (
              <ActionItem
                icon="edit"
                label="Sửa"
                onClick={() => handleAction("edit", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.propose.updateDetailSim") &&
            isPending ? (
              <ActionItem
                icon="menu"
                label="Cập nhật"
                onClick={() => handleAction("update", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.propose.updateDetailSim") &&
            isPending &&
            isEsim &&
            supplierName ? (
              <ActionItem
                icon="boxConfirm"
                label={`Nhập từ ${supplierName}`}
                onClick={() => handleAction("buy-from-supplier", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.propose.browse") && isPending ? (
              <ActionItem
                icon="approval"
                label="Duyệt"
                onClick={() => handleAction("approve", record)}
              />
            ) : (
              <React.Fragment />
            )}

            {/* {permissions.includes("warehouse.propose.refuse") && isPending ? (
              <ActionItem
                icon="cancelApproval"
                label="Từ chối"
                onClick={() => handleAction("reject", record)}
              />
            ) : (
              <React.Fragment />
            )} */}
            {permissions.includes("warehouse.propose.exportSim") &&
            isPending ? (
              <ActionItem
                icon="downloadRed"
                label="Xuất excel"
                onClick={() => handleAction("export", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.propose.importSim") &&
            isPending ? (
              <ActionItem
                icon="import"
                label="Import Excel"
                onClick={() => handleAction("import", record)}
              />
            ) : (
              <React.Fragment />
            )}
          </PopupAction>
        )
      },
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
    // fetchData(newPagination, filter, keyword, tabStatus)
  }

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <FilterRequest
        filter={filter}
        setFilter={setFilter}
        setKeyword={setKeyword}
        //  searchValue={searchValue}
        //  setSearchValue={setSearchValue}
        //  handleSearch={handleSearch}
      />
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>

      <TableCustom
        rowKey="ID"
        showPagination
        isPrimary
        bordered
        loading={loading}
        scroll={{ x: "max-content" }}
        // rowSelection={{
        //   type: "checkbox",
        //   onChange: (_, selected) => setSelectedRows(selected),
        // }}
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
      />

      {viewModalVisible && (
        <ModalDetailProposal
          open={viewModalVisible}
          onCancel={() => setViewModalVisible(false)}
          isEditMode={false}
          onOk={() => {
            setViewModalVisible(false)
            setRefresh(prev => !prev)
          }}
          editData={selectedRecord}
          onlyView={true}
        />
      )}

      {editModalVisible && (
        <ModalDetailProposal
          // open={editModalVisible}
          // onCancel={() => setEditModalVisible(false)}
          // onOk={() => {
          //   setEditModalVisible(false)
          //   setRefresh(prev => !prev)
          // }}
          // record={selectedRecord}
          open={editModalVisible}
          onCancel={() => setEditModalVisible(false)}
          isEditMode={true}
          onOk={() => {
            setEditModalVisible(false)
            setRefresh(prev => !prev)
          }}
          editData={selectedRecord}
          refresh={setRefresh}
        />
      )}
      {approveModalVisible && (
        <Modal
          title="Xác nhận duyệt"
          open={approveModalVisible}
          onOk={async () => {
            setConfirmLoading(true)
            await approveProposal(selectedRecord)
            setConfirmLoading(false)
            setApproveModalVisible(false)
          }}
          onCancel={() => setApproveModalVisible(false)}
          okText="Duyệt"
          cancelText="Hủy"
          confirmLoading={confirmLoading}
        >
          <p>
            Bạn có chắc chắn muốn duyệt phiếu{" "}
            <strong>{selectedRecord?.batch_number}</strong> không?
          </p>
        </Modal>
      )}

      {rejectModalVisible && (
        <Modal
          title="Nhập lý do từ chối"
          open={rejectModalVisible}
          onOk={rejectProposal}
          onCancel={() => {
            setRejectModalVisible(false)
            setRejectReason("")
          }}
          okText="Xác nhận từ chối"
          cancelText="Hủy"
          confirmLoading={loading}
        >
          <Input.TextArea
            rows={4}
            placeholder="Nhập lý do từ chối..."
            value={rejectReason}
            onChange={e => setRejectReason(e.target.value)}
          />
        </Modal>
      )}
      {isModalImport && (
        <CustomModal
          title={"Tải file lên"}
          footer={null}
          size={"small"}
          open={isModalImport}
          onCancel={() => setIsModalImport(false)}
        >
          <ImportModal
            setIsModalImport={setIsModalImport}
            recordId={selectedRecord?.ID}
            // apiDownloadTemplate={WarehouseService.getWarehouseExcelTemplate}
            apiUploadTemplate={ProposalService.importInfoSimProposal}
            onCancel={() => {
              setIsModalImport(false)
              setSelectedRecord()
            }}
            setRefresh={setRefresh}
          />
        </CustomModal>
      )}
      {isModalUpdate && (
        <ModalInputSim
          visible={isModalUpdate}
          onClose={() => {
            setIsModalUpdate(false)
            setIsApprove(false)
          }}
          onSubmit={() => {
            setIsModalUpdate(false)
            setRefresh(prev => !prev)
            if (isApprove) {
              approveProposal(idUpdate)
              setIsApprove(false)
            }
          }}
          id={idUpdate}
          idStatus={{
            request_id: checkStatus.request_id,
            supplierCode: checkStatus.supplierCode,
          }}
        />
      )}
    </div>
  )
}

export default ListWarehouseInRequest

